/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_Photo_GoneInputs */

const en_us2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo deleted`)
};

const pt_br2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto apagada`)
};

const es_419_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto borrada`)
};

const pt_pt2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto apagada`)
};

const fr_fr2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo supprimée`)
};

const de_de2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto gelöscht`)
};

const it_it2_body_assessment_compare_photo_gone = /** @type {(inputs: Body_Assessment_Compare_Photo_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto eliminata`)
};

/**
* | output |
* | --- |
* | "Photo deleted" |
*
* @param {Body_Assessment_Compare_Photo_GoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_photo_gone = /** @type {((inputs?: Body_Assessment_Compare_Photo_GoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Photo_GoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_photo_gone(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_photo_gone(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_photo_gone(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_photo_gone(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_photo_gone(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_photo_gone(inputs)
	return en_us2_body_assessment_compare_photo_gone(inputs)
});
export { body_assessment_compare_photo_gone as "body-assessment.compare_photo_gone" }